import React from "react";
import DeathRates from "./components/DeathRates";
import SmallScenarioSim from "./components/SmallScenarioSim";
import LargeImmunocompromisedSim from "./components/LargeImmunocompromisedSim";
import WithSocialDistancingControls from "./components/WithSocialDistancingControls";
import WithResurgenceControls from "./components/WithResurgenceControls";
import graphGenerator from "./components/graphGenerator";
import SIRmodelVis from "./components/SIRmodelVis";

import "./App.css";
import SIRmodelWithWaves from "./components/SIRmodelWithWaves";
import ScrollyNetwork from "./components/ScrollyNetwork";
import HeaderGraphic from "./components/HeaderGraphic";
import FootNotesManager from "./components/FootNotesManager";

const size = 360;
const results = graphGenerator(size, Math.ceil(size * 0.03));
console.log(results);

function App() {
  const deathRates = {
    immunoNoBeds: 0.1,
    immunoWithBed: 0.8,
    severeNoBeds: 0.7,
    severeWithBeds: 0.95
  };

  return (
    <div className="App">
      <HeaderGraphic />
      <ScrollyNetwork />
      <FootNotesManager />

      <svg>
        <SmallScenarioSim portalId={"simple-spread-simulation"} />

        <LargeImmunocompromisedSim
          graph={results}
          portalId={"big-spread-simulation"}
          deathRates={deathRates}
        />

        <WithSocialDistancingControls
          graph={results}
          portalId={"with-social-distancing"}
          deathRates={deathRates}
        />

        <WithResurgenceControls
          graph={results}
          portalId={"resurgence-simulation"}
          deathRates={deathRates}
        />
      </svg>
      <SIRmodelVis portalId={"SIR-model-vis"} />
      <DeathRates deathRates={deathRates} />
      <SIRmodelWithWaves />
    </div>
  );
}

export default App;
